import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined'
import {LoadingButton} from '@mui/lab'
import {Chip, Theme} from '@mui/material'
import {SxProps} from '@mui/system'
import React, {FC} from 'react'
import {useTranslation} from 'react-i18next'

import {SHIFT_EVENT_DETAILS_WIDGET_NAMESPACE} from '../consts'

type SubmitSectionProps = {
  isSubmitted: boolean
  onSubmit?: () => void
  sx?: SxProps<Theme>
  isLoading?: boolean
}

export const SubmitSection: FC<SubmitSectionProps> = ({isSubmitted, onSubmit, sx, isLoading}) => {
  const {t} = useTranslation(SHIFT_EVENT_DETAILS_WIDGET_NAMESPACE)

  if (onSubmit && !isSubmitted) {
    return (
      <LoadingButton
        onClick={onSubmit}
        loading={isLoading}
        color="secondary"
        variant="outlined"
        startIcon={<CheckOutlinedIcon />}
        data-test-id="stoppage-submit-button"
      >
        {t('shiftEvent.action.submit')}
      </LoadingButton>
    )
  }

  return (
    <Chip
      icon={isSubmitted ? <CheckOutlinedIcon /> : undefined}
      label={isSubmitted ? t('shiftEvent.label.submitted') : t('shiftEvent.label.notSubmitted')}
      data-test-id={`stoppage-submit-chip-${isSubmitted ? 'submitted' : 'not-submitted'}`}
      color={isSubmitted ? 'success' : 'secondary'}
      variant="outlined"
      sx={sx}
    />
  )
}
